<div class="container-fluid main-container my-5">
  <div class="pt-3">
    <h1 class="subtitle mt-4">Maak meedoen mogelijk via Stichting Steddie!</h1>
    <hr class="horizontal-ruler">
    <p class="info-text mt-2">
      Heeft jouw organisatie activiteiten die gericht zijn op mensen met een lichamelijke of
      verstandelijke beperking, psychische klachten of autisme?
      Stichting Steddie biedt een unieke kans om dit aanbod gratis zichtbaar te maken voor een
      doelgroep die vaak moeite heeft om passende vrijetijdsactiviteiten te vinden.
    </p>
    <p class="info-text mt-2">
      Door jouw activiteiten op onze website te plaatsen, bereik je niet alleen een bredere groep
      deelnemers, maar draag je ook bij aan een inclusieve samenleving waarin iedereen,
      ongeacht beperking, kan deelnemen aan sociale, culturele of sportieve evenementen.
    </p>
    <h4 class="subtitle mt-4"><i>Waarom meedoen met Stichting Steddie?</i></h4>
    <p class="info-text mt-2">
      <b>- Toegang tot een specifieke doelgroep:</b>
      <br>
      Onze website wordt bezocht door mensen met een beperking en hun families, begeleiders
      en zorgprofessionals. Jouw activiteit komt direct onder de aandacht van hen die het meest
      baat hebben bij een passend vrijetijdsaanbod.
    </p>
    <p class="info-text mt-2">
      <b>- Ondersteuning bij inclusie:</b>
      <br>
      Door jouw aanbod toegankelijk te maken, help je mee aan het doorbreken van drempels en
      het creëren van gelijke kansen voor iedereen.
    </p>
    <p class="info-text mt-2">
      <b>- Kosteloze plaatsing:</b>
      <br>
      Het aanmelden van activiteiten op Steddie.nl is volledig gratis. Zo kun je zonder financiële
      verplichtingen jouw maatschappelijke betrokkenheid tonen.
    </p>
    <p class="info-text mt-2">
      <b>- Samen bouwen aan een inclusieve toekomst:</b>
      <br>
      Jouw bijdrage helpt niet alleen jouw organisatie zichtbaar te maken, maar zorgt er ook voor
      dat mensen met een beperking meer mogelijkheden hebben om deel te nemen aan de
      maatschappij.
    </p>
    <p class="info-text mt-2">
      Sluit je aan bij de groeiende lijst van organisaties die de waarde van toegankelijkheid
      erkennen, en zet jouw activiteit op de kaart! Plaats jouw activiteit eenvoudig en snel op ons
      platform.
    </p>
    <img class=" mx-auto d-block img-together" src="assets/img/Samen-ervoor-zorgen.png">
  </div>
  <div class="row faq-questions mt-4">
    <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">

      <div class="panel panel-default">
        <div class="panel-heading" role="tab">
          <h4 class="panel-title">
            <a class="collapsed" role="button" data-bs-toggle="collapse" data-bs-parent="#accordion"  [attr.data-bs-target]="'#flush-collapse-1'" aria-expanded="true" [attr.aria-controls]="'flush-collapse-1'">
              Oké, ik ben enthousiast. Hoe plaats ik een activiteit op Steddie.nl?
            </a>
          </h4>
        </div>
        <div id="flush-collapse-1" class="panel-collapse collapse in" role="tabpanel" [attr.aria-labelledby]="'flush-heading-1'">
          <div class="panel-body">
            <p>
              STAP 1 <br>
              De eerste keer ga je jouw organisatie <a [routerLink]="['/account/registreren-organisatie']"><b>registreren</b></a>. Dit doe je eenmalig. <br>
              <br>
              We vragen je om het volgende in te vullen: <br>
              - Naam en adresgegevens van jouw organisatie. <br>
              - Naam en telefoonnummer van de contactpersoon van jouw organisatie. <br>
              - Emailadres en (zelfgekozen) wachtwoord. <br>
              <br>
              De gegevens van de contactpersoon komen bij de activiteit te staan. Handig als een
              geïnteresseerde nog vragen heeft. Het mailadres wordt gebruikt voor de aanmelding van
              deelnemers. <br>
            </p>
            <button type="button" [routerLink]="['/account/registreren-organisatie']" class="btn btn-register mt-3">
              Registreren
            </button>
            <p>
              <br>
              STAP 2 <br>
              Nadat je de gegevens hebt ingevuld, verschijnt er automatisch een extra knop ‘Activiteit
              plaatsen’ in het menu. In de mobiele versie verschijnt de optie in het menu aan de
              rechterzijde.<br>
              <br>
              Wat moet je invullen bij het plaatsen van een activiteit? <br>
              - Naam en beschrijving van de activiteit. <br>
              - Categorie waaronder de activiteit valt (bijvoorbeeld ‘Sport of ‘Feest’).<br>
              - Voor wie is de activiteit geschikt? (bijvoorbeeld ‘Autisme’) Er zijn meerdere doelgroepen mogelijk. <br>
              - Waar, wanneer en hoe laat vindt de activiteit plaats? <br>
              - De verschillende onderdelen en tijden. <br>
              <br>
              Je kunt als optie een eigen foto of flyer van de activiteit uploaden. Hiermee valt de activiteit extra op!
            </p>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading" role="tab">
          <h4 class="panel-title">
            <a class="collapsed" role="button" data-bs-toggle="collapse" data-bs-parent="#accordion"  [attr.data-bs-target]="'#flush-collapse-2'" aria-expanded="true" [attr.aria-controls]="'flush-collapse-2'">
              Moeten wij als organisatie iets betalen als we een activiteit plaatsen?
            </a>
          </h4>
        </div>
        <div id="flush-collapse-2" class="panel-collapse collapse in" role="tabpanel" [attr.aria-labelledby]="'flush-heading-2'">
          <div class="panel-body">
            <p>
              Nee, het plaatsen van een activiteit op onze website is helemaal gratis.
              Dit doen wij omdat we graag willen dat er zoveel mogelijk verschillende activiteiten op de website staan.
            </p>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading" role="tab">
          <h4 class="panel-title">
            <a class="collapsed" role="button" data-bs-toggle="collapse" data-bs-parent="#accordion"  [attr.data-bs-target]="'#flush-collapse-3'" aria-expanded="true" [attr.aria-controls]="'flush-collapse-3'">
              Onze activiteiten staan al op onze eigen website, waarom zouden we deze dan ook op Steddie.nl plaatsen?
            </a>
          </h4>
        </div>
        <div id="flush-collapse-3" class="panel-collapse collapse in" role="tabpanel" [attr.aria-labelledby]="'flush-heading-3'">
          <div class="panel-body">
            <p>
              Het lijkt allemaal een beetje dubbelop en alleen maar extra werk. Maar nu is het nog zo dat
              mensen op verschillende websites en in kranten en op social media moeten zoeken naar
              geschikte activiteiten. Dat kost veel tijd en daar heeft eigenlijk niemand zin in (toch?).
              <br>
              <br>
              We vergelijken Steddie.nl weleens met een winkel zoals Action. Als je daar weleens geweest
              bent, herken je het vast: je gaat voor één dingetje heen en komt met veel meer thuis.
              <br>
              <br>
              <b>Waarom?</b>
              <br>
              Heel simpel: je wordt, terwijl je daar rondloopt, vanzelf op ideeën gebracht voor andere
              dingen. Zo is het ook op onze website.
              <br>
              Iemand is op zoek naar een passende sport, maar ziet ook dat er een dansavond of
              bijvoorbeeld een speldag in de buurt wordt georganiseerd. Iets waar ze anders nooit naar op
              zoek naar waren gegaan.
              <br>
              <br>
              Ook een website als Markplaats is al jaren een succes, juist door het grote en veelzijdige
              aanbod.
            </p>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading" role="tab">
          <h4 class="panel-title">
            <a class="collapsed" role="button" data-bs-toggle="collapse" data-bs-parent="#accordion"  [attr.data-bs-target]="'#flush-collapse-4'" aria-expanded="true" [attr.aria-controls]="'flush-collapse-4'">
              Onze organisatie heeft geen kennis, tijd of zin om een activiteit op Steddie.nl te plaatsen. Wat nu?
            </a>
          </h4>
        </div>
        <div id="flush-collapse-4" class="panel-collapse collapse in" role="tabpanel" [attr.aria-labelledby]="'flush-heading-4'">
          <div class="panel-body">
            <p>
              Geen probleem. Juist omdat wij het zo belangrijk vinden dat er zoveel mogelijk verschillende
              activiteiten op Steddie.nl staan, zorgen wij daarvoor.
              <br>
              <br>
              <b>Hoe?</b>
              <br>
              Stuur ons een bericht of bel ons, en wij zorgen ervoor dat jullie activiteit ook zichtbaar wordt
              op Steddie.nl. Dat doen wij graag en gratis, als extra service van onze kant.
            </p>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading" role="tab">
          <h4 class="panel-title">
            <a class="collapsed" role="button" data-bs-toggle="collapse" data-bs-parent="#accordion"  [attr.data-bs-target]="'#flush-collapse-5'" aria-expanded="true" [attr.aria-controls]="'flush-collapse-5'">
              Hoe zit het met de promotie van de activiteiten op Steddie.nl?
            </a>
          </h4>
        </div>
        <div id="flush-collapse-5" class="panel-collapse collapse in" role="tabpanel" [attr.aria-labelledby]="'flush-heading-5'">
          <div class="panel-body">
            <p>
              Stichting Steddie zorgt voor de promotie van de activiteiten. Dat doen wij met een
              uitgebreide advertentiecampagne op Google, via social media, maar ook lokaal via flyers en
              het benaderen van Zorginstellingen en verenigingen.
              <br>
              <br>
              Uiteraard help het ook als je binnen jouw eigen organisatie de activiteit(en) op Steddie.nl
              promoot. Want mond-tot-mond reclame werkt nog steeds het beste.
            </p>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading" role="tab">
          <h4 class="panel-title">
            <a class="collapsed" role="button" data-bs-toggle="collapse" data-bs-parent="#accordion"  [attr.data-bs-target]="'#flush-collapse-6'" aria-expanded="true" [attr.aria-controls]="'flush-collapse-6'">
              Wij zijn wel geïnteresseerd, maar willen eerst persoonlijk contact met Stichting Steddie
            </a>
          </h4>
        </div>
        <div id="flush-collapse-6" class="panel-collapse collapse in" role="tabpanel" [attr.aria-labelledby]="'flush-heading-6'">
          <div class="panel-body">
            <p>
              Wij komen graag in contact met jouw organisatie en beantwoorden alle vragen waar je nog
              mogelijk mee rondloopt voordat je een activiteit plaatst.
            </p>
            <br>
            <p class="text-center">
              Stichting Steddie is telefonisch bereikbaar via <a href="tel:072-5314614">072- 5 314 614</a>
              <br>
              via WhatsApp: <a href="tel:06-48411585">06- 484 11 585</a>
              <br>
              en via mail: <a href="mailto: info@steddie.nl">info&#64;steddie.nl</a>
            </p>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading" role="tab">
          <h4 class="panel-title">
            <a class="collapsed" role="button" data-bs-toggle="collapse" data-bs-parent="#accordion"  [attr.data-bs-target]="'#flush-collapse-7'" aria-expanded="true" [attr.aria-controls]="'flush-collapse-7'">
              Wij willen graag een activiteit organiseren, maar we hebben geen ervaring...
            </a>
          </h4>
        </div>
        <div id="flush-collapse-7" class="panel-collapse collapse in" role="tabpanel" [attr.aria-labelledby]="'flush-heading-7'">
          <div class="panel-body">
            <p>
              Laat een gebrek aan ervaring je niet tegen houden om iets geweldigs te organiseren voor
              mensen met een beperking!
              <br>
              Stichting Steddie helpt je daar graag mee omdat wij het belangrijk vinden dat zoveel mogelijk
              mensen kunnen meedoen. Neem gerust contact met ons op als je hier meer over wil weten.
              <br>
              <br>
              Onze uitgebreide ervaring omvat onder andere het organiseren van speciale speldagen en
              aangepaste sportevenementen. Bovendien beschikken we over een uitgebreide database
              met contactgegevens voor subsidieaanvragen.
              <br>
              <br>
              <b>Wil je meer informatie?</b>
              <br>
              Stuur een bericht naar <a href="mailto: martin@steddie.nl">martin&#64;steddie.nl</a> en we nemen binnen 24 uur contact met je op.
              Bellen kan natuurlijk ook. De contactgegevens staan onderaan deze pagina.
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
